<script lang="ts">
	import Divider from "../atoms/Divider.svelte"
	import MenuItem from "../atoms/MenuItem.svelte"
	export let click: () => void = undefined
	export let selected: boolean = false
	export let divider: boolean = false
	export let level: number = 0
</script>

{#if divider}
	<Divider/>
{/if}

<MenuItem
	click={click}
	selected={selected}
	level={level}
>
	<slot></slot>
</MenuItem>

<style lang="postcss">
</style>